export default [
  {
    name: "finstreamds",
    label: "FinStream (Data API)",
    info: "Get a normalized data stream of your end users PSD2 transactional history, as available in their payment accounts and provided via our PSD2-based connected banks.\n",
    enabled: true,
  },
  {
    name: "finstreamvf",
    label: "FinStream (Verification)",
    info: "Verify your end users’ financial information. Connect to our Data Mining service based on our Data API. We do the heavy lifting on banking integrations, data normalization and mining, to serve you with the financial information of your end users, verified by their own, up-to-date, and real-time banking transactions.",
    enabled: true,
  },
  {
    name: "finscoreqs",
    label: "Finclude Score (Questionnaire data)",
    info: "A creditworthiness assessment based on your end-users’ self-declared information. Your users answer some very basic questions around their financial profile and they are able to get a taste of how their data translate into a creditworthiness assessment. The journey to financial well being starts on financial education.",
    enabled: true,
  },
  {
    name: "finscorefs",
    label: "Finclude Score (Pre-Aggregated data | Ad Hoc)",
    info: "A creditworthiness assessment based on the proprietary, pre-aggregated data you have on your end-users. You can use large volumes of your existing data pool and assess the creditworthiness of your end-users instantly.",
    enabled: true,
  },
  {
    name: "finscorevf",
    label: "Finclude Score (Verified | Questionnaire + Verification)",
    info: "A creditworthiness assessment based on your end-users’ self-declared information that have been verified via our PSD2-based bank connections. Your end-user answers a short questionnaire with some very basic questions around their financial profile, we verify their answers via their transactional history we get from our PSD2 bank connections, and we adjust their score accordingly.",
    enabled: false,
  },
  {
    name: "finscorebv",
    label:
      "Finclude Score (Behavioral | Verified + Cont.Verification) - Coming soon",
    info: "A creditworthiness & affordability assessment based on end users’ transactional behavior over time. Your end-users keep their bank account connected and we update their score nearly real-time (up to four times a day) based on their spending patterns.",
    enabled: false,
  },
  { name: "magpie", label: "Magpie - Coming soon", enabled: false },
];
